import { parseAbi } from 'viem/utils';

export const approval = parseAbi(['function approve(address spender, uint256 value) external returns (bool)']);
export const safeMint = parseAbi(['function safeMint(address owner) view returns (uint balance)']);
export const joinOrRebuy = parseAbi(['function joinOrRebuy(uint256 tableId, uint256 buyIn) public']);
export const joinTable = parseAbi(['function joinTable(uint256 tableId, uint256 buyIn) public']);
export const rebuy = parseAbi(['function rebuy(uint256 tableId, uint256 amount) public']);
export const transfer = parseAbi(['function transfer(address to, uint256 value) public returns (bool)']);
export const redeem = parseAbi(['function redeemTokens(uint256 amount) external']);
export const getTokenPrice = parseAbi(['function getTokenPrice() external view returns (uint256)']);
